import React, { useEffect, useState } from "react";
import axios from "../axios";
import {
  Box,
  CircularProgress,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Tooltip,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
} from "@mui/material";
import { DateRange, Language, School } from "@mui/icons-material";
import PetsIcon from "@mui/icons-material/Pets";
import DeleteIcon from "@mui/icons-material/Delete";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "./Layout";
import CorsiInsegnanteAddModal from "./CorsiInsegnanteAddModal";
import CourseMTDetailModal from "./CourseMTDetailModal";
import CorsoLezioni from "./CorsoLezioni";
import AddIcon from "@mui/icons-material/Add";
import { Switch, FormControlLabel } from "@mui/material";
import AutorenewIcon from "@mui/icons-material/Autorenew";

const levelColorMapping = {
  1: "#FFECB3", // Pastel Yellow
  2: "#C8E6C9", // Pastel Green
  3: "#B3E5FC", // Pastel Sky Blue
  4: "#BBDEFB", // Pastel Blue
  5: "#FFCDD2", // Pastel Red
  6: "#B2DFDB", // Pastel Teal Green
  7: "#E1BEE7", // Pastel Lavender
  8: "#FFE0B2", // Pastel Orange
};

const CorsiInsegnante = () => {
  const [loading, setLoading] = useState(true);
  const [corsi, setCorsi] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [motivation, setMotivation] = useState(""); // Stato per la motivazione
  const [notes, setNotes] = useState(""); // Stato per le note
  const [isSubmitting, setIsSubmitting] = useState(false); // Stato per il submit
  const [motivationExists, setMotivationExists] = useState(false);
  const [selectedCourseData, setSelectedCourseData] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [mostraTerminati, setMostraTerminati] = useState(true);
  const [corsiTerminati, setCorsiTerminati] = useState([]);

  const [isRenewing, setIsRenewing] = useState(false);


    useEffect(() => {
        const fetchPermissions = () => {
            let permissions = [];
            try {
                permissions = JSON.parse(localStorage.getItem('permissions')) || [];
            } catch (error) {
                console.error('Error parsing permissions:', error);
                permissions = [];
            }
            setPermissions(permissions);
        };

        fetchPermissions();
    }, []);



  const fetchCorsi = async () => {
    try {
      const token = localStorage.getItem("token"); // Get the token from local storage

      const response = await axios.post("datahandler/corsi-insegnante", {
        token: token,
      });

      setCorsi(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching corsi:", error);
    }
  };

  const fetchCorsiTerminati = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post("datahandler/corsi-insegnante", {
        token: token,
        terminati: true,
      });
      setCorsiTerminati(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Errore nel recupero corsi terminati:", error);
    } finally {
    }
  };

  const fetchAllCorsi = async () => {
    setLoading(true);
    fetchCorsi();
    if (mostraTerminati) {
      fetchCorsiTerminati();
    } else {
      setCorsiTerminati([]);
    }

  };

  const checkMotivationExists = async () => {
    try {
      const token = localStorage.getItem("token"); // Get the token from local storage
      const response = await axios.post(
        "/datahandler/no-corsi-get-motivation",
        {
          token: token,
        }
      );

      if (response.data.motivations && response.data.motivations.length > 0) {
        setMotivationExists(true);
      } else {
        setMotivationExists(false);
      }
    } catch (error) {
      console.error("Error checking motivations:", error);
    }
  };



const handleArchiveCourse = async (idCorso) => {
  const token = localStorage.getItem("token");

  Swal.fire({
    title: "Vuoi davvero cancellare questo corso?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#ffa000",  // arancione
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Sì, cancella!",
    cancelButtonText: "Annulla",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const response = await axios.post("/datahandler/riattiva-corso", {
          idCorso,
          token,
          bypassRiattiva: true
        });

        if (response.data.success) {
          toast.success("Corso cancellato con successo");
          fetchAllCorsi(); // Ricarica i corsi
        } else {
          Swal.fire({
            icon: "error",
            title: "Errore",
            text: response.data.error || "Errore durante la cancellazione.",
          });
        }
      } catch (error) {
        const errorMsg = error.response?.data?.exception?.[0]?.message || 'Errore nella richiesta. Si prega di riprovare.';
        Swal.fire({
          icon: "error",
          title: "Errore",
          text: errorMsg,
        });
        console.error("Errore durante la cancellazione del corso:", error);
      }
    }
  });
};


  useEffect(() => {
    fetchAllCorsi();
    checkMotivationExists(); // Controlla se ci sono motivazioni salvate
  }, []);

  const handleAddCourse = () => {
    setSelectedCourseData(null);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedCourseData(null);
    setIsRenewing(false); // 👈 reset
  };

  const handleSaveCourse = (courseData) => {
    // Handle saving the course
    console.log("Course data:", courseData);
    handleCloseModal();
    fetchAllCorsi();
  };

  const handleCourseClick = async (courseId) => {
    console.log("Clicked course ID:", courseId);
    setSelectedCourseId(courseId);
  };

  const handleDeleteCourse = async (courseId) => {
    const token = localStorage.getItem("token"); // Get the token from local storage

    Swal.fire({
      title: "Sei sicuro?",
      text: "Questa operazione non può essere annullata!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sì, cancella!",
      cancelButtonText: "Annulla",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post("datahandler/delete-corso", {
            token: token,
            idCorso: courseId,
          });

          if (response.data.success) {
            toast.success("Corso eliminato con successo");
            fetchAllCorsi(); // Ricarica i corsi
          } else {
            Swal.fire({
              icon: "error",
              title: "Errore",
              text: response.data.error,
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Errore",
            text: "Errore nella richiesta. Si prega di riprovare.",
          });
          console.error("Errore nella richiesta:", error);
        }
      }
    });
  };

  const formatDateString = (dateString) => {
    if (dateString) {
      const year = parseInt(dateString.substring(0, 4));
      const month = parseInt(dateString.substring(4, 6)) - 1;
      const day = parseInt(dateString.substring(6, 8));
      return format(new Date(year, month, day), "dd/MM/yyyy");
    } else return "ERRORE";
  };

  const handleSubmitNoCorsi = async () => {
    setIsSubmitting(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        "datahandler/no-corsi-save-motivation",
        {
          token: token,
          motivation: motivation,
          notes: notes,
        }
      );

      if (response.data.success) {
        toast.success("Motivazione salvata con successo");
        setMotivation("");
        setNotes("");

        // Ricontrolla se esiste una motivazione e ricarica i corsi
        await checkMotivationExists();
        await fetchAllCorsi();
      } else {
        toast.error("Errore nel salvataggio della motivazione");
      }
    } catch (error) {
      toast.error("Errore nella richiesta. Si prega di riprovare.");
      console.error("Errore nella richiesta:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCourseEdit = async (courseId) => {
    try {
      const token = localStorage.getItem("token");

      // Effettua una chiamata per ottenere i dettagli del corso da modificare
      const response = await axios.post("datahandler/get-corso-details", {
        token: token,
        idCorso: courseId,
      });

      if (response.data.success) {
        // Popola il modal di aggiunta corso con i dettagli esistenti del corso
        setSelectedCourseData(response.data.course_details); // Popola i campi esistenti
        setModalOpen(true); // Apre il modal per l'editing
      } else {
        toast.error("Errore nel recupero dei dettagli del corso.");
      }
    } catch (error) {
      toast.error("Errore nella richiesta. Si prega di riprovare.");
      console.error("Errore nella richiesta:", error);
    }
  };

  const handleReactivateCourse = async (courseId) => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.post("datahandler/get-corso-details", {
        token: token,
        idCorso: courseId,
      });

      if (response.data.success) {
        // Prepara i dati escludendo le date
        const courseDetails = {
          ...response.data.course_details,
        };

        courseDetails.data_inizio_corso = "";
        courseDetails.data_fine_corso = "";

        courseDetails.start_date = "";
        courseDetails.end_date = "";
        setIsRenewing(true); // 👉 indica che si sta riattivando
        setSelectedCourseData(courseDetails); // Imposta i dati senza le date
        setModalOpen(true); // Apre il modal
      } else {
        toast.error("Errore nel recupero dei dettagli del corso.");
      }
    } catch (error) {
      toast.error("Errore nella richiesta. Si prega di riprovare.");
      console.error("Errore nella richiesta:", error);
    }
  };

  const renderCard = (corso, isTerminato = false) => {
    const backgroundColor = isTerminato
      ? "#e0e0e0" // Grigio chiaro per corsi terminati
      : levelColorMapping[corso.livello] || "#FFE0B2";

    const oggi = new Date().toISOString().slice(0, 10).replace(/-/g, "");

    const corsoIniziato = corso.data_inizio_corso <= oggi;

    return (
      <Card
        key={corso.ID}
        sx={{
          marginBottom: 2,
          width: "100%",
          backgroundColor: backgroundColor,
          cursor: "pointer",
        }}
      >
        <Card
          sx={{
            marginBottom: 2,
            width: "100%",
            backgroundColor: backgroundColor,
            cursor: "pointer",
          }}
        >
          <CardContent onClick={() => handleCourseClick(corso.ID)}>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={8}>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    backgroundColor: isTerminato ? "#bdbdbd" : "primary.main",
                    color: isTerminato ? "black" : "white",
                    "&:hover": {
                      backgroundColor: isTerminato ? "#9e9e9e" : "primary.dark",
                    },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCourseClick(corso.ID);
                  }}
                >
                  {corso.post_title}{" "}
                </Button>{" "}
              </Grid>
              <Grid item xs={3}>
                <Typography variant="body3"> {corso.tipocorso} </Typography>{" "}
              </Grid>
              <Grid item xs={1}>
                {" "}
                {(!corso.numalunni ||
                  corso.numalunni === "0" ||
                  corso.numalunni === 0) &&
                  !isTerminato && (
                    <Tooltip title="Elimina corso">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteCourse(corso.ID);
                        }}
                      >
                        <DeleteIcon color="error" />
                      </IconButton>{" "}
                    </Tooltip>
                  )}{" "}
              </Grid>{" "}
            </Grid>{" "}
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={6}>
                <Grid container spacing={1} alignItems="center">
                  <Grid item>
                    <PetsIcon />
                  </Grid>{" "}
                  <Grid item>
                    <Typography variant="body2">
                      {" "}
                      {corso.numalunni == ""
                        ? "Nessun alunno associato"
                        : `${corso.numalunni}  alunni`}{" "}
                    </Typography>{" "}
                  </Grid>{" "}
                </Grid>{" "}
              </Grid>{" "}
              <Grid item xs={6}>
                <Grid container spacing={1} alignItems="center">
                  <Grid item>
                    <DateRange />
                  </Grid>{" "}
                  <Grid item>
                    <Typography variant="body2">
                      {" "}
                      {`Dal: ${formatDateString(
                        corso.data_inizio_corso
                      )} Al: ${formatDateString(corso.data_fine_corso)}`}{" "}
                    </Typography>{" "}
                  </Grid>{" "}
                </Grid>{" "}
              </Grid>{" "}
              <Grid item xs={6}>
                <Grid container spacing={1} alignItems="center">
                  <Grid item>
                    <Language />
                  </Grid>{" "}
                  <Grid item>
                    <Typography variant="body2">
                      {" "}
                      {`Lingua: ${corso.lingua}`}{" "}
                    </Typography>{" "}
                  </Grid>{" "}
                </Grid>{" "}
              </Grid>{" "}
              <Grid item xs={6}>
                <Grid container spacing={1} alignItems="center">
                  <Grid item>
                    <School />
                  </Grid>{" "}
                  <Grid item>
                    <Typography variant="body2">
                      {" "}
                      {`Scuola: ${corso.scuola || "N/A"}`}{" "}
                    </Typography>{" "}
                  </Grid>{" "}
                </Grid>{" "}
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2">
                  {" "}
                  {`Livello: ${corso.livello}`}{" "}
                </Typography>{" "}
              </Grid>{" "}
              <Grid item xs={6}>
                <Typography variant="body2">
                  {" "}
                  {`Gruppo età: ${corso.gruppoeta}`}{" "}
                </Typography>{" "}
              </Grid>{" "}
            </Grid>{" "}
            {!corsoIniziato && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  mt: 2,
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCourseEdit(corso.ID);
                  }}
                >
                  Modifica Corso{" "}
                </Button>{" "}
              </Box>
            )}
            {isTerminato && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#ff9800", // Arancione brillante
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#fb8c00",
                      },
                    }}
                    startIcon={<AutorenewIcon />}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleReactivateCourse(corso.ID);
                    }}
                  >
                    Riattiva il corso{" "}
                  </Button>{" "}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#d32f2f", // Rosso acceso per azione distruttiva
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#c62828",
                      },
                    }}
                    startIcon={<DeleteIcon />}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleArchiveCourse(corso.ID);
                    }}
                  >
                    Elimina il corso{" "}
                  </Button>{" "}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 2,
                  }}
                >
                  {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCourseEdit(corso.ID);
                    }}
                  >
                    Modifica Corso{" "}
                  </Button>{" "} */}
                </Box>{" "}
              </>
            )}{" "}
          </CardContent>{" "}
        </Card>
        {!corso.numalunni == "" && (
          <Box
            sx={{
              mt: 2,
            }}
          >
            <CorsoLezioni courseId={corso.ID} />{" "}
            {/* Passa l'ID del corso e il token */}{" "}
          </Box>
        )}{" "}
      </Card>
    );
  };

  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
          mt: 4,
        }}
      >
        {loading ? (
          <CircularProgress />
        ) : (
          <Box
            sx={{
              width: "100%",
            }}
          >

            {(!(corsi.length > 0) && !loading) ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    mb: 2,
                  }}
                >
                  Non ci sono corsi futuri caricati.{" "}
                </Typography>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: 600,
                    p: 3,
                    borderRadius: 2,
                    boxShadow: 3,
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    Aggiungi un nuovo corso{" "}
                  </Typography>{" "}
                  <Typography
                    variant="body1"
                    sx={{
                      mb: 2,
                    }}
                  >
                    Non hai ancora aggiunto un corso per i tuoi studenti.{" "}
                  </Typography>{" "}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddCourse}
                    startIcon={<AddIcon />}
                  >
                    Aggiungi Corso{" "}
                  </Button>{" "}
                </Box>
                {!motivationExists && (
                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: 600,
                      p: 3,
                      borderRadius: 2,
                      boxShadow: 3,
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <Typography variant="h6" gutterBottom>
                      Fornisci una motivazione{" "}
                    </Typography>{" "}
                    <Typography
                      variant="body1"
                      sx={{
                        mb: 2,
                      }}
                    >
                      Se non puoi aggiungere corsi al momento, per favore
                      fornisci una motivazione.{" "}
                    </Typography>{" "}
                    <FormControl
                      fullWidth
                      sx={{
                        mb: 2,
                      }}
                    >
                      <InputLabel> Motivazione </InputLabel>{" "}
                      <Select
                        value={motivation}
                        onChange={(e) => setMotivation(e.target.value)}
                        label="Motivazione"
                      >
                        <MenuItem value="Nessun alunno disponibile">
                          Nessun alunno disponibile{" "}
                        </MenuItem>{" "}
                        <MenuItem value="Problemi tecnici">
                          Problemi tecnici{" "}
                        </MenuItem>{" "}
                        <MenuItem value="Problemi di salute">
                          Problemi di salute{" "}
                        </MenuItem>{" "}
                        <MenuItem value="Altro"> Altro </MenuItem>{" "}
                      </Select>{" "}
                    </FormControl>{" "}
                    <TextField
                      label="Note"
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                      multiline
                      rows={4}
                      fullWidth
                      sx={{
                        mb: 2,
                      }}
                    />{" "}
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleSubmitNoCorsi}
                      disabled={isSubmitting}
                      fullWidth
                    >
                      Salva Motivazione{" "}
                    </Button>{" "}
                  </Box>
                )}{" "}
              </Box>
            ) : (
              <>
                {" "}
                {/* Aggiungi Corso Button (Always Visible) */}{" "}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddCourse}
                    startIcon={<AddIcon />}
                  >
                    Aggiungi Corso{" "}
                  </Button>
 
 { permissions.includes('all') &&(
                  <FormControlLabel
                    control={
                      <Switch
                        checked={mostraTerminati}
                        onChange={() => setMostraTerminati((prev) => !prev)}
                        color="primary"
                      />
                    }
                    label="Mostra corsi terminati"
                  />
                  )}


                </Box>
                {mostraTerminati && permissions.includes('all') &&(
                  <Box
                    sx={{
                      mt: 6,
                      width: "100%",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        mb: 2,
                      }}
                    >
                      Corsi terminati{" "}
                    </Typography>
                    {loading ? (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <CircularProgress size={24} />{" "}
                      </Box>
                    ) : corsiTerminati.length === 0 ? (
                      <Typography
                        variant="body2"
                        sx={{
                          fontStyle: "italic",
                        }}
                      >
                        Nessun corso terminato trovato.{" "}
                      </Typography>
                    ) : (
                      corsiTerminati.map((corso) => renderCard(corso, true))
                    )}{" "}
                  </Box>
                )}
                <Typography
                  variant="h6"
                  sx={{
                    mb: 2,
                  }}
                >
                  Corsi attivi{" "}
                </Typography>{" "}
                {/* Render Corsi */} {corsi.map((corso) => renderCard(corso))}{" "}
              </>
            )}{" "}
          </Box>



        )}
        {selectedCourseId !== null && (
          <CourseMTDetailModal
            open={true}
            onClose={() => setSelectedCourseId(null)}
            idCorso={selectedCourseId}
            refreshCourses={fetchAllCorsi}
          />
        )}{" "}
      </Box>

      <CorsiInsegnanteAddModal
        open={modalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSaveCourse}
        selectedCourseData={selectedCourseData} // Passa i dati del corso selezionato al modal
        refreshCourses={fetchAllCorsi}
        renew={isRenewing}
      />

      <ToastContainer />
    </Layout>
  );
};

export default CorsiInsegnante;
